import React from "react";
import { HeaderExtended, Button } from '@imedcl/design-system'
export default function MenuContent() {
    return (
        <HeaderExtended
            actions={<Button Icon={function noRefCheck() { }} className="!p-0" type="danger" />}
            hiddenUser
            isCompactLogo
            subProductLogo={<h1 className="text-secondary-imed-60 font-bold text-xl mt-5">Pago de facturas </h1>}
            truncateLabel={false}
        />
    );
}
